<div *ngIf="assignedReportFolders != undefined && assignedReportFolders.length > 0 ">
    <div class="flex-content">
        <mat-table style="width: 100%;" #table [dataSource]="tylerMatData" multiTemplateDataRows matSort
        matSortDisableClear matSortActive="FolderName" id="assignedReportsFoldersTable"
        aria-label="Assigned Reports Folder" tabindex="0">

        <!-- More -->
        <ng-container matColumnDef="More">
            <mat-header-cell *matHeaderCellDef>
                <i [ngClass]="isExpandAll ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                (click)="expandAll()" aria-hidden="true"></i>
            </mat-header-cell>
            <mat-cell *matCellDef="let element">
                <span aria-label="Expand row for more details">
                    <i [ngClass]="checkExpanded(element) ? 'detail-row-expanded-icon' : 'detail-row-collapsed-icon'" class="material-icons"
                        aria-hidden="true"></i>
                </span>
            </mat-cell>
        </ng-container>

        <!-- FolderName -->
        <ng-container matColumnDef="FolderName">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                <span translate>Folder</span>
                <filter [data]="tylerMatData" columnName="FolderName" dataType="string" id="FolderNameFilter"
                    class="mat-filter">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let mrf">
                {{mrf.FolderName}}
            </mat-cell>
        </ng-container>

        <!-- FolderDescription -->
        <ng-container matColumnDef="FolderDescription">
            <mat-header-cell *matHeaderCellDef mat-sort-header>
                <span translate>Description</span>
                <filter [data]="tylerMatData" columnName="FolderDescription" dataType="string"
                    id="descriptionFilter" class="mat-filter">
                </filter>
            </mat-header-cell>
            <mat-cell *matCellDef="let mrf">
                {{mrf.FolderDescription}}
            </mat-cell>
        </ng-container>

        <!-- expandedDetail -->
        <ng-container matColumnDef="expandedDetail">
            <mat-cell *matCellDef="let mrf; let j = dataIndex" class="mat-detail-card">
                <!-- Report Areas Table -->
                <mat-table [dataSource]="mrf.AssignedReportsInFolder" style="width: 50%;" multiTemplateDataRows
                    class="subjectAreaTable">

                    <!-- ReportName -->
                    <ng-container matColumnDef="ReportName">
                        <mat-header-cell *matHeaderCellDef>
                            <span translate>Reports</span>
                        </mat-header-cell>
                        <mat-cell *matCellDef="let rpt">
                            <a class="link" (click)="reportClick(rpt)">{{rpt.Description}}</a>
                        </mat-cell>
                    </ng-container>

                    <!-- Row Definitions -->
                    <mat-header-row *matHeaderRowDef="reportAreaColumns; sticky: true" id="reportsHeader">
                    </mat-header-row>
                    <mat-row *matRowDef="let rpt; columns: reportAreaColumns; let j = dataIndex"
                        id="folder_report{{j}}" tabIndex="0" style="overflow: hidden;">
                    </mat-row>
                </mat-table>
            </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnDisplay; sticky: true" id="myReportsFoldersHeader">
        </mat-header-row>
        <!-- Data rows -->
        <mat-row *matRowDef="let row; columns: columnDisplay; let i = index;"
            id="assignReportsFoldersDataRow{{i}}" tabindex="0" style="padding:0px;overflow:hidden;" matRipple
            (click)="toggleExpanded(row)" (keydown)="rowKeyPress($event, row)">
        </mat-row>
        <mat-row *matRowDef="let row; columns: ['expandedDetail']"
            [@detailExpand]="checkExpanded(row) ? 'expanded' : 'collapsed'" style="overflow: hidden"
            class="mat-detail-row">
        </mat-row>
    </mat-table>
    </div>
  </div>
